// extracted by mini-css-extract-plugin
export default {"description":"CobraCensus_description__x24Vl","descriptionList":"CobraCensus_descriptionList__7YTz9","censusContainer":"CobraCensus_censusContainer__IpuaP"};